import axios from 'axios';
import {
  APP_SETTING_CUSTOM_DOMAINS_UPDATE_BEGIN,
  APP_SETTING_CUSTOM_DOMAINS_UPDATE_SUCCESS,
  APP_SETTING_CUSTOM_DOMAINS_UPDATE_FAILURE,
  APP_SETTING_CUSTOM_DOMAINS_UPDATE_DISMISS_ERROR,
} from './constants';
import cookie from 'react-cookies';
import { toast } from 'react-toastify';

export function customDomainsUpdate(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_CUSTOM_DOMAINS_UPDATE_BEGIN,
    });
    const token = cookie.load('token');
    const config = {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    };
    const { projectId, formData } = args;
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_ORGANIZATION_ENGINE}projects/${projectId}`,
        formData,
        config,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_CUSTOM_DOMAINS_UPDATE_SUCCESS,
            data: res,
          });
          resolve(res);
          toast.success('Domains updated successfully');
        },
        (err) => {
          dispatch({
            type: APP_SETTING_CUSTOM_DOMAINS_UPDATE_FAILURE,
            data: { error: err },
          });
          reject(err);
          toast.error('Failed to update domains');
        },
      );
    });

    return promise;
  };
}

export function dismissCustomDomainsUpdateError() {
  return {
    type: APP_SETTING_CUSTOM_DOMAINS_UPDATE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_CUSTOM_DOMAINS_UPDATE_BEGIN:
      return {
        ...state,
        customDomainsUpdatePending: true,
        customDomainsUpdateError: null,
      };

    case APP_SETTING_CUSTOM_DOMAINS_UPDATE_SUCCESS:
      return {
        ...state,
        customDomainsUpdatePending: false,
        customDomainsUpdateError: null,
      };

    case APP_SETTING_CUSTOM_DOMAINS_UPDATE_FAILURE:
      return {
        ...state,
        customDomainsUpdatePending: false,
        customDomainsUpdateError: action.data.error,
      };

    case APP_SETTING_CUSTOM_DOMAINS_UPDATE_DISMISS_ERROR:
      return {
        ...state,
        customDomainsUpdateError: null,
      };

    default:
      return state;
  }
}
